<template lang="pug">
  section.card
    .card-content
      p O cadastro na Área Administrativa é realizada por um(a) Administrador(a) do Sistema.
      p Caso você não possua acesso, solicite a um(a).
      hr
      p Essa Área Administrativa é restirta e apenas os usuários cadastrados podem acessar os seus recursos.
</template>

<script>
  export default {
    name: 'authHelpModal'
  }
</script>

<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// HelpModal.vue?74daf5ce